import { render, staticRenderFns } from "./MarketingAndUpsell.vue?vue&type=template&id=4577438c&scoped=true"
import script from "./MarketingAndUpsell.vue?vue&type=script&lang=js"
export * from "./MarketingAndUpsell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577438c",
  null
  
)

export default component.exports